import React from 'react';
import { token } from '@atlaskit/tokens';

const primaryColor = token('color.icon');
const baseColor = token('color.background.neutral');

export const ChatIcon = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.2672 24.8747L14.1058 25.0336V24.0883C14.1058 23.1218 13.3223 22.3383 12.3558 22.3383H11.9424H11.933L11.9236 22.3385C8.16922 22.3951 4.98752 19.8399 4.33501 16.3892C4.01162 14.3703 4.61966 12.3077 6.0189 10.7402C7.42398 9.16627 9.4892 8.24873 11.6766 8.25H11.6773H20.9067C23.089 8.25845 25.1455 9.18099 26.5429 10.755L27.4777 9.92516L26.5429 10.755C27.935 12.3232 28.5376 14.3829 28.2122 16.3979C27.56 19.849 24.3781 22.4045 20.6234 22.3479L20.6143 22.3478L20.6052 22.3478C18.2421 22.3465 15.9656 23.2459 14.2789 24.8633L14.273 24.869L14.2672 24.8747Z"
			fill={baseColor}
			stroke={primaryColor}
			strokeWidth="2.5"
		/>
		<path
			d="M21.7589 17.2496C20.8103 17.2496 20.0413 16.4829 20.0413 15.5371C20.0413 14.5912 20.8103 13.8245 21.7589 13.8245C22.7075 13.8245 23.4766 14.5912 23.4766 15.5371C23.4766 16.4829 22.7075 17.2496 21.7589 17.2496Z"
			fill={primaryColor}
		/>
		<path
			d="M10.7824 17.2496C9.83373 17.2496 9.06472 16.4829 9.06472 15.5371C9.06472 14.5912 9.83373 13.8245 10.7824 13.8245C11.731 13.8245 12.5 14.5912 12.5 15.5371C12.5 16.4829 11.731 17.2496 10.7824 17.2496Z"
			fill={primaryColor}
		/>
		<path
			d="M16.2667 17.2496C15.3181 17.2496 14.5491 16.4829 14.5491 15.5371C14.5491 14.5912 15.3181 13.8245 16.2667 13.8245C17.2154 13.8245 17.9844 14.5912 17.9844 15.5371C17.9844 16.4829 17.2154 17.2496 16.2667 17.2496Z"
			fill={primaryColor}
		/>
	</svg>
);
